//
//
//

export default {
  props: {
    value: 0
  },
  computed: {
    objClass () {
      if (parseInt(this.value) === 1) {
        return 'fd-male male-color'
      } else if (parseInt(this.value) === 2) {
        return 'fd-female female-color'
      } else {
        return
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/gender/index.vue